import { createRouter, createWebHashHistory } from 'vue-router'
import { useAdminAuthStore } from '@/stores/adminAuth'

function resolveLoginNext(to) {
  const next = String(to?.query?.next || '').trim()
  if (!next || next === '/login') return null
  return next
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/AdminLoginPage.vue'),
    meta: {
      public: true,
      title: 'Admin Login',
      description: 'Đăng nhập vào Admin Control Plane của bot-trade.',
    },
  },
  {
    path: '/',
    component: () => import('@/components/AdminLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAdmin: true, title: 'Admin', description: 'Admin Control Plane của bot-trade.' },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/pages/AdminDashboardPage.vue'),
        meta: {
          title: 'Dashboard',
          description: 'Tổng quan hệ thống bot-trade phân tán, cập nhật realtime qua Socket.IO.',
        },
      },
      {
        path: 'servers',
        name: 'Servers',
        component: () => import('@/pages/AdminServersPage.vue'),
        meta: {
          title: 'Servers',
          description: 'Danh sách các server và worker node đang kết nối với Admin Hub.',
        },
      },
      {
        path: 'bots',
        name: 'Bots',
        component: () => import('@/pages/AdminBotsPage.vue'),
        meta: {
          title: 'Bots',
          description: 'Danh sách bots tập trung từ mọi worker để theo dõi và thao tác nhanh.',
        },
      },
      {
        path: 'monitored',
        name: 'Monitored',
        component: () => import('@/pages/AdminMonitoredPage.vue'),
        meta: {
          title: 'Monitored',
          description: 'Phân tích monitored symbols tập trung cho Admin với cùng logic AVG như worker.',
        },
      },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAdminAuthStore()
  if (!auth._restored) await auth.restore()
  if (to.meta.requiresAdmin && !auth.authenticated) {
    return { name: 'Login', query: { next: to.fullPath } }
  }
  if (to.name === 'Login' && auth.authenticated) {
    const next = resolveLoginNext(to)
    return next || { name: 'Dashboard' }
  }
  return true
})

export default router
